<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
            <a-input :disabled="params.isShow" placeholder="请输入经销商名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入经销商名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="编号">
            <a-input :disabled="params.isShow" placeholder="请输入经销商编号" v-decorator="[
          'code',
          {initialValue:data.code,rules: [{ required: true, message: '请输入经销商编号' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户类别">
            <a-select placeholder="请选择客户类别" :options="this.dealerTypeOptions" v-decorator="['dealerType',{initialValue:data.dealerType,rules: [{ required: true, message: '请选择客户类别'}]}]"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
            <a-input :disabled="params.isShow" placeholder="请输入联系人" v-decorator="[
          'contact',
          {initialValue:data.contact,rules: [{ required: true, message: '请输入联系人' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :disabled="params.isShow" placeholder="请输入联系电话" v-decorator="[
          'telephone',
          {initialValue:data.telephone,rules: [{ required: true, message: '请输入联系电话' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效期">
            <a-range-picker :disabled="this.params.isShow" v-decorator="[
          'rangeTime',
          {initialValue:data.rangeTime,rules: [{ required: true, message: '请选择有效期' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售组织">
            <a-select placeholder="请选择销售组织" @change="orgChange" :options="this.organizationOptions" v-decorator="['organizationId',{initialValue:data.organizationId,rules: [{ required: true, message: '请选择销售组织'}]}]"></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
            <a-select placeholder="请选择部门" :options="this.departmentOptions" v-decorator="['departmentId',{initialValue:data.departmentId,rules: [{ required: true, message: '请选择部门'}]}]"></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售员">
            <a-input v-if="this.params.isShow" :read-only="true" placeholder="请选择销售员" v-decorator="[
          'saleEmployeeName',
          {initialValue:data.saleEmployeeName,rules: [{ required: true, message: '请选择销售员' }]}]"></a-input>

            <a-input-search v-else :read-only="true" placeholder="请选择销售员" enterButton="选择" @search="onEmployeeSearch" v-decorator="[
          'saleEmployeeName',
          {initialValue:data.saleEmployeeName,rules: [{ required: true, message: '请选择销售员' }]}]"></a-input-search>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址">
            <a-cascader :disabled="this.params.isShow" :options="addressOptions" expandTrigger="hover" @change="changeAddressdata" placeholder="请选择地址" v-decorator="[
          'defaultValue',
          {initialValue:defaultValue,rules: [{ required: true, message: '请选择地址' }]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详细地址">
            <a-input :read-only="this.params.isShow" placeholder="请输入详细地址" v-decorator="[
          'address',
          {initialValue:data.address,rules: [{ required: true, message: '请输入详细地址' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
    <hp-manager-modal width="1000px" title="选择销售员" v-model="selectEmployeeVisible">
      <hp-manager-page-employee-select slot="slot" @getSelectedEmployee="getSelectedEmployee" @cancel="selectEmployeeVisible = false"></hp-manager-page-employee-select>
    </hp-manager-modal>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import hpManagerPageEmployeeSelect from "./../../Basic/Employee/SelectList";
const defaultData = {
  id: 0,
  name: "",
  code: "",
  dealerType: undefined,
  organizationId: undefined,
  departmentId: undefined,
  contact: "",
  telephone: "",
  rangeTime: null,
  isActive: 1
};
export default {
  name: "hp-manager-page-Dealer-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  components: {
    hpManagerPageEmployeeSelect
  },
  data() {
    return {
      loading: false,
      addressOptions: config.addressJson,
      selectEmployeeVisible: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      departmentOptions: [],
      organizationOptions: [],
      dealerTypeOptions: [],
      employeeId: null
    };
  },

  async mounted() {
    if (this.params.id) {
      // this.data = Object.assign(this.params,defaultData)
      this.getDetailDealer();
    } else {
      this.data = exzends(defaultData);
    }
    this.getOrganizationOptions();
    this.getDealerTypeOptions();
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    changeAddressdata(option) {
      console.log(option);
      this.data.provinceId = parseInt(option[0]);
      this.data.cityId = parseInt(option[1]);
      if (option[2]) {
        this.data.districtId = option[2];
      }
      console.log(this.form);
      this.form.setFieldsValue({
        provinceId: this.data.provinceId
      });
    },
    async getOrganizationOptions() {
      let orgList = await api.GetOrganizationSelect();
      if (orgList) {
        orgList.forEach(a => {
          this.organizationOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    onEmployeeSearch() {
      this.selectEmployeeVisible = true;
    },
    getSelectedEmployee(p) {
      this.selectEmployeeVisible = false;
      this.form.setFields({ saleEmployeeName: { value: p.name, errors: null } });
      this.employeeId = p.id;
    },
    async orgChange(value) {
      this.departmentOptions = [];
      await this.getDepartmentOptions(value);
      this.form.resetFields(["departmentId"]);
    },
    async getDepartmentOptions(orgId) {
      let departmentList = await api.GetDepartmentSelect({ orgId: orgId });
      if (departmentList) {
        departmentList.forEach(a => {
          this.departmentOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    async getDealerTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 3 });
      if (dictionary) {
        dictionary.forEach(a => {
          this.dealerTypeOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    async getDetailDealer() {
      this.loading = true;
      let result = await api.GetDealer({ DealerId: this.params.id });
      if (result) {
        this.data = result;
        this.data.rangeTime = [
          new moment(this.data.startTime),
          new moment(this.data.endTime)
        ];
        this.defaultValue = [
          this.data.provinceId + "",
          this.data.cityId + "",
          this.data.districtId + ""
        ];
        this.data.dealerType = this.data.dealerType + "";
        this.data.organizationId =
          this.data.organizationId != null
            ? this.data.organizationId + ""
            : undefined;
        this.data.departmentId =
          this.data.departmentId != null
            ? this.data.departmentId + ""
            : undefined;
        if (this.data.organizationId != null) {
          await this.getDepartmentOptions(this.data.organizationId);
        }
        this.employeeId = this.data.saleEmployeeId;
      }
      console.log(this.defaultValue);
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateDealer(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        code: value.code,
        telephone: value.telephone,
        organizationId: parseInt(value.organizationId),
        departmentId: parseInt(value.departmentId),
        startTime: value.rangeTime[0].startOf("day").valueOf(),
        endTime: value.rangeTime[1].startOf("day").valueOf(),
        provinceId: this.data.provinceId,
        cityId: this.data.cityId,
        districtId: this.data.districtId,
        saleEmployeeId: this.employeeId,
        address: value.address,
        dealerType: parseInt(value.dealerType),
        contact: value.contact
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.AddOrUpdateDealer(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddOrUpdateDealer(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Dealer/Add.vue